import React, { useState } from "react";
import { toast } from "sonner";
import { Send, Loader2, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/i18n";

const COPY = {
  newsletter: {
    title: { fr: "Newsletter diaspora", en: "Diaspora newsletter" },
    text: {
      fr: "Recevez par e-mail les actualités, projets et rendez-vous d'ANYANG BETI.",
      en: "Get ANYANG BETI news, projects and events by email.",
    },
  },
  rencontre: {
    title: { fr: "Rappel de la grande rencontre", en: "Annual gathering reminder" },
    text: {
      fr: "Soyez prévenu(e) dès que le conseil d'administration fixe la date de la grande rencontre annuelle.",
      en: "Get notified as soon as the board sets the date of the annual gathering.",
    },
  },
};

export const SubscribeForm = ({ type = "newsletter", variant = "inline" }) => {
  const { tr, lang } = useLang();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const copy = COPY[type];

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/subscribe", { email: email.trim(), type, lang });
      toast.success(data.message || tr({ fr: "Inscription enregistrée.", en: "You're subscribed." }));
      setDone(true);
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || tr({ fr: "Adresse e-mail invalide.", en: "Invalid email address." }));
    } finally {
      setBusy(false);
    }
  };

  const compact = variant === "footer";

  return (
    <div data-testid={`subscribe-${type}`} className={compact ? "" : "ab-hairline bg-ab-ebony p-8"}>
      {!compact && (
        <>
          <h3 className="font-serif text-2xl text-ab-ivory">{tr(copy.title)}</h3>
          <p className="mt-2 text-ab-ivory/65 text-sm max-w-md">{tr(copy.text)}</p>
        </>
      )}
      {compact && (
        <>
          <h4 className="text-ab-gold text-xs tracking-widest uppercase mb-2">{tr(copy.title)}</h4>
          <p className="text-ab-ivory/55 text-sm mb-4 max-w-xs">{tr(copy.text)}</p>
        </>
      )}

      {done ? (
        <p className="mt-4 flex items-center gap-2 text-ab-green text-sm" data-testid={`subscribe-done-${type}`}>
          <CheckCircle2 size={16} /> {tr({ fr: "Merci ! Vous êtes bien inscrit(e).", en: "Thank you! You're subscribed." })}
        </p>
      ) : (
        <form onSubmit={submit} className={`mt-4 flex ${compact ? "flex-col sm:flex-row" : "flex-col sm:flex-row"} gap-3`}>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={tr({ fr: "votre@email.com", en: "you@email.com" })}
            data-testid={`subscribe-input-${type}`}
            className="flex-1 bg-ab-black/40 border border-ab-gold/20 focus:border-ab-gold/60 outline-none text-ab-ivory placeholder:text-ab-ivory/30 px-4 py-3 text-sm transition-colors rounded-none"
          />
          <button
            type="submit"
            disabled={busy}
            data-testid={`subscribe-submit-${type}`}
            className="ab-btn-primary shrink-0 justify-center"
          >
            {busy ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />}
            {tr({ fr: "S'inscrire", en: "Subscribe" })}
          </button>
        </form>
      )}
    </div>
  );
};

export default SubscribeForm;
